export const topMenuLayoutTestIds = {
  topMenu: 'top-menu',
  topMenuRow: 'top-menu-row',
  topMenuLeft: 'top-menu-left',
  topMenuRight: 'top-menu-right',
};
